import React from 'react';
import { Outlet } from 'react-router-dom';
import { AccountAreaGuard } from '../../components/guards/AccountAreaGuard';

export const MainBrand: React.FC = () => {
  return (
    <AccountAreaGuard area="brand">
      <Outlet />
    </AccountAreaGuard>
  );
};
